import {FormControl, Grid, InputLabel, MenuItem,Select} from "@mui/material";
import React from "react";
import { sortDropdownByDisplayOrder } from "../../utilities/tp-validations";

function transactionBidDropdown(props) {
    const isError = (
            props.errorFields.length !== 0 &&
                props.transactions &&
                props.transactions.bids[0][props.id] == "");
    return (
        <Grid item xs={props.xs}>
            <FormControl fullWidth error={isError}>
                <InputLabel
                    htmlFor="Films"
                    id="Films-label"
                    required={true}
                >
                    {props.label}
                </InputLabel>
            <Select
                value={props.transactions && props.transactions.bids[0][props.id]}
                readOnly={props.actionType.action === "view"}
                fullWidth={true}
                id={props.id}
                label={props.label}
                MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
                onChange={(event) => {
                    props.setTransactionBidDropdownValue(props.id, event.target.value);
                    if (props.id === "saleReason") {
                        props.transactions.bids.forEach((bid) => {
                            props.setBidsTextValue(props.id, event.target.value, bid.bidType);
                        });
                    }
                }}
            >
                {createDomainDropdownOption(sortDropdownByDisplayOrder(props.options))}
            </Select>
            </FormControl>
        </Grid>
    );
}

const createDomainDropdownOption = (options) => {
    if (options && options.length !== 0) {
        return options.map((item, index) => {
            return (
                <MenuItem key={index} value={item.domainValue}>
                    {item.domainValue}
                </MenuItem>
            );
        });
    }
};

export default transactionBidDropdown;